module.exports = __webpack_public_path__ + "static/media/市值风云助教-企微码.2ab7c706.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_173/img/市值风云助教-企微码.png
// module id = 1600
// module chunks = 0